// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import QRCode from '../../_common/api/QRCode';
import Button from '../../_common/form/Button';
import Title from '../../_common/form/Title';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import Card from '../Card';
import Row from '../../_common/form/Row';
import Col from '../../_common/form/Col';
import { OSs } from '../../_common/api/utility';
import { Navigate } from 'react-router-dom';

const Code = styled(Title)`
    color: red;
    font-weight: bold;
    line-height: 1;
    padding: 0.2em 0;
`

const StoreDirect = ({ ...props }) => {
    const {
        state: {
            active_user,
            site_config,
            OS
        },
    } = useGlobalState();

    const [statement, setStatement] = useState('')

    // const referralURL = `${window.location.origin}/storeDirect#${active_user.account.referralCode}`

    console.log(OS);

    useEffect(() => {
        switch (OS) {
            case OSs.IOS:
                if (site_config.appStore.apple) {
                    window.location.href = site_config.appStore.apple;
                    setStatement('Opening Apple App Store.')
                } else {
                    window.location.href = `${window.location.origin}/signUp${window.location.hash}`
                }
                break;
            case OSs.Android:
                if (site_config.appStore.google) {
                    window.location.href = site_config.appStore.google;
                    setStatement('Opening Google App Store.')
                } else {
                    window.location.href = `${window.location.origin}/signUp${window.location.hash}`
                }
                break;
            default:
                window.location.href = `${window.location.origin}/signUp${window.location.hash}`
                break;
        }
    }, [OS]);

    return (
        <Card>
            <Title>App Download</Title>
            {statement}
        </Card>
    );
}

export default StoreDirect; 